import Base from '../../_config/base';

class Newsgrid extends Base {
  constructor(el) {
    super(el);

    const showMoreButton = el.querySelector('.newsGrid__button_more');
    const showLessButton = el.querySelector('.newsGrid__button_less');
    const cards = el.querySelectorAll('.newsGrid__card');

    const cardLimit = el.querySelector('.newsGrid__grid').getAttribute('data-grid-limit') || 7;
    const minCardLimit = +cardLimit;
    let nextCardLimit = +cardLimit;

    if (showMoreButton) {
      showMoreButton.addEventListener('click', () => {
        nextCardLimit += minCardLimit;
        [...cards].forEach((card, index) => {
          if (index < nextCardLimit) {
            card.classList.remove('card__collapsed');
          }
        });
        if (nextCardLimit >= cards.length) {
          showMoreButton.classList.add('hidden');
        }
        showLessButton.classList.remove('hidden');
      });
    }

    if (showLessButton) {
      showLessButton.addEventListener('click', () => {
        if (nextCardLimit > minCardLimit) {
          nextCardLimit -= minCardLimit;
        }
        [...cards].forEach((card, index) => {
          if (index >= nextCardLimit) {
            card.classList.add('card__collapsed');
          }
        });
        if (nextCardLimit === minCardLimit) {
          showLessButton.classList.add('hidden');
        }
        showMoreButton.classList.remove('hidden');
      });
    }
  }
}

Newsgrid.className = 'Newsgrid';
export default Newsgrid;
